import { createReducer, on } from "@ngrx/store";
import * as RolesActions from "../actions/roles.actions";
import { RolesData } from "../models/roles.model";
import { ACTION, ActionState, STATE } from "@ptg-shared/constance/value.const";

export const RoleFeatureKey = 'role';

export interface State {
  isLoading: boolean;
  rolesData: RolesData;
  actionState?: ActionState;
  clientModules: any;
  errorMsgRemove: string;
  success?: boolean;
  error?: any;
}

const initialState: State = {
  isLoading: true,
  rolesData: {
    total: 0,
    roles: []
  },
  actionState: undefined,
  clientModules: [],
  errorMsgRemove: ''
};

export const reducer = createReducer(
  initialState,
  on(RolesActions.getRoles, (state) => ({
    ...state,
    isLoading: true,
    rolesData: {
      total: 0,
      roles: []
    }
  })),
  on(RolesActions.getRolesSuccess, (state, { rolesData }) => ({
      ...state,
      isLoading: false,
      rolesData,
      success: true,
      error: undefined
  })),
  on(RolesActions.getRolesFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    rolesData: {
      total: 0,
      roles: []
    },
    success: false,
    error: error
  })),
  on(RolesActions.getRolesByPortalType, (state) => ({
    ...state,
    isLoading: true,
    rolesData: {
      total: 0,
      roles: []
    }
  })),
  on(RolesActions.getRolesByPortalTypeSuccess, (state, { rolesData }) => ({
      ...state,
      isLoading: false,
      rolesData,
      success: true,
      error: undefined
  })),
  on(RolesActions.getRolesByPortalTypeFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    rolesData: {
      total: 0,
      roles: []
    },
    success: false,
    error: error
  })),
  on(RolesActions.removeRole, (state) => ({
    ...state,
    isLoading: true,
    rolesData: {
      total: 0,
      roles: []
    }
  })),
  on(RolesActions.removeRoleSuccess, (state) => ({
    ...state,
    actionState: {
      action: ACTION.REMOVE,
      state: STATE.SUCCESS
    }
  })),
  on(RolesActions.removeRoleFailure, (state, { errorMsg }) => ({
    ...state,
    actionState: {
      action: ACTION.REMOVE,
      state: STATE.FAIL
    },
    errorMsgRemove: errorMsg
  })),
  on(RolesActions.updateRoleSuccess, (state) => ({
    ...state,
    actionState: {
      action: ACTION.EDIT,
      state: STATE.SUCCESS
    }
  })),
  on(RolesActions.createtRoleSuccess, (state) => ({
    ...state,
    actionState: {
      action: ACTION.ADD,
      state: STATE.SUCCESS
    }
  })),
  on(RolesActions.updateRoleFailure, (state) => ({
    ...state,
    actionState: {
      action: ACTION.EDIT,
      state: STATE.FAIL
    }
  })),
  on(RolesActions.createRoleFailure, (state) => ({
    ...state,
    actionState: {
      action: ACTION.ADD,
      state: STATE.FAIL
    }
  })),
  on(RolesActions.rolesClear, (state) => ({
    ...state,
    actionState: undefined
  })),
  on(RolesActions.getAllPermissions, (state) => ({
    ...state,
    clientModules: []
  })),
  on(RolesActions.getAllPermissionsSuccess, (state, { clientModules }) => ({
      ...state,
    clientModules
  })),
  on(RolesActions.getAllPermissionsFailure, (state, { errorMsg }) => ({
    ...state,
    clientModules: []
  })),

);
